import React from 'react';
import FontAwesome from 'react-fontawesome';
import { Button } from "react-bootstrap";

const ComponentLockButton = ({
  lockFn,
  locked,
  subject = ''
}) => /*#__PURE__*/React.createElement(Button, {
  style: {},
  variant: "secondary",
  size: "sm",
  title: (locked ? 'Edit ' : 'Finish editing ') + subject,
  className: "py-0 mr-2",
  onClick: lockFn
}, /*#__PURE__*/React.createElement(FontAwesome, {
  name: locked ? 'fas fa-edit' : 'far fa-check'
}), /*#__PURE__*/React.createElement("span", null, "\xA0", locked ? 'Edit' : 'Done'));

export default ComponentLockButton;